import { MkuSubmenu } from '../menu';

MkuSubmenu.install = function (Vue) {
  Vue.component(MkuSubmenu.name, MkuSubmenu);
};

export default MkuSubmenu;
